import type { FeatureDefinition } from "../types"

// Use this array to add new mobile features with controllable rollout percentage
export const MOBILE_FEATURES: FeatureDefinition[] = [
]

